<template>
  <div>
    <div :class="{
      'sc-progress mt-2 mb-4 sc-progress-3': true
    }" v-if="currentSetupStep > -1">
      <div class="progress-track"></div>
      <div :class="{
          'progress-step': true,
          'is-complete': currentSetupStep > index,
          'is-active': currentSetupStep === index
        }" v-for="(step, index) in steps" :key="step">
        <IconCheck />
        <label>{{step}}</label>
      </div>
    </div>

    <router-view v-if="routeReady"></router-view>
    <Loading class="text-center" v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import routeReady from '@/mixins/routeReady'

import '@/assets/scss/_progressbar.scss'

export default {
  mixins: [ routeReady ],
  computed: {
    ...mapState([ 'currentSetupStep' ]),
    steps: function () {
      return [
        'AMP',
        'Plan',
        'Done'
      ]
    }
  }
}
</script>
